<template>
  <div class="block" id="map_log_data">
    <h2 style="font-size: 24px">
      日志查询
      <el-tooltip placement="right">
        <div slot="content">仅支持查询7天内的数据</div>
        <img class="img-help" src="@/assets/images/icon_help.png" />
      </el-tooltip>
    </h2>
    <div class="row">
      <title-name
        title=" "
        :btn="btnOptions"
        @selectChange="selectChange"
      ></title-name>
      <el-radio-group class="room-type-radio" v-model="productState.room_type" v-if="productState.type === '1'">
        <el-radio
          v-for="item in roomTypeOptions"
          :key="item.id"
          :label="item.id"
        >
          {{ item.label }}
        </el-radio>
      </el-radio-group>
    </div>
    <div class="content-inner-wrap">
      <div class="data-filter" v-if="productState.type !== '4'">
        <span class="mgr25">选择日期</span>
        <el-date-picker
          v-model="query.selectDate[0]"
          type="datetime"
          :pickerOptions="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
          @change="handleStartDateTimeChange"
        >
        </el-date-picker>
        <span style="margin: 0 10px">~</span>
        <el-date-picker
          v-model="query.selectDate[1]"
          type="datetime"
          :disabled="true"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-button @click="handleSearch" class="search_btn" type="info">
          查找
        </el-button>
        <span v-if="productState.type !== '3'">
          <el-radio-group v-model="dayNum" size="medium" @change="clickDate">
            <el-radio-button label="2">近2天</el-radio-button>
            <el-radio-button label="7">近7天</el-radio-button>
          </el-radio-group>
        </span>
        <span v-if="productState.type === '3'">
          <i class="el-icon-warning"></i>
          <span>支持筛选6小时内的报错日志</span>
        </span>
      </div>
      <div v-if="productState.type === '4'">
        <el-button @click="handleSearch" class="search_btn cpu_search_btn" type="info">
          查找
        </el-button>
        <span>
          <i class="el-icon-warning"></i>
          <span>支持展示30天内房间cpu超100%产生的火焰图日志</span>
        </span>
      </div>
    </div>
    <el-dialog title="ss_lua_error日志" :visible.sync="luaErrorLogDialog" width="68%">
      <span class="download-wrap" @click="exportFn">
        <img src="@/assets/images/icon_export.png" />
        <span>导出数据</span>
      </span>
      <div class="data-table" v-loading="luaErrorLogLoading">
        <el-table id="ssLuaErrLog" class="data-box" border :data="luaErrorLogList" stripe>
          <el-table-column
            scope="row"
            label="id"
            prop="aid"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="日志内容"
            prop="err_detail"
            align="center"
          >
            <template slot-scope="scope">
              <vue-ellipsis
                :visible-line="3"
                :text="scope.row.err_detail"
                reflow-on-resize
                :ellipsis="luaErrorLogList[scope.$index].ellipsis"
                :on-ellipsis-click="
                  () => {
                    luaErrorLogList[scope.$index].ellipsis = false;
                  }
                "
                :on-unellipsis-click="
                  () => {
                    luaErrorLogList[scope.$index].ellipsis = true;
                  }
                "
              >
                <template slot="ellipsisNode">
                  <el-link
                    type="primary"
                    :underline="false"
                    style="margin-left: 16px"
                    >展开</el-link
                  >
                </template>
                <template slot="unellipsisNode">
                  <el-link
                    type="primary"
                    style="margin-left: 16px"
                    :underline="false"
                  >
                    收起</el-link
                  >
                </template>
              </vue-ellipsis>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="img-no">
              <img
                class="img-no-data"
                src="../../../assets/images/img_table_no_data.png"
              />
              <div class="noCart">暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <template #footer>
        <span>
          <el-button @click="luaErrorLogDialog = false">Cancel</el-button>
          <el-button type="primary" @click="luaErrorLogDialog = false">OK</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog :title="productState.type === '3' ? 'studio地图报错日志' : '通用服务器日志'" :visible.sync="studioLogDialog" width="68%">
      <div v-loading="studioLogLoading">
        <div class="btnGroup">
          <span class="mgr25">Uin</span>
          <el-input
            v-model="suin"
            class="mgr25"
            style="width: 200px"
            placeholder="请输入uin"
          />
          <el-button type="primary" @click="handleSearchStudioLog">查询</el-button>
        </div>
        <div class="data-table">
          <el-table id="studioLog" class="data-box" border :data="studioLogList" stripe>
            <el-table-column
              label="主机"
              prop="hostname"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="文件名"
              prop="filename"
              align="center"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              prop="timestamp"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column label="下载" width="100" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="sdudioDownload(scope.row)">下载</el-button>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="img-no">
                <img
                  class="img-no-data"
                  src="../../../assets/images/img_table_no_data.png"
                />
                <div class="noCart">暂无数据</div>
              </div>
            </template>
          </el-table>
          <br>
          <div style="text-align: center;">
            <el-pagination
              background
              @current-change="CurrentChange"
              :current-page="studioLogPageInfo.page"
              :page-size="studioLogPageInfo.limit"
              layout="prev, pager, next,jumper"
              :total="studioLogPageInfo.total"
              hide-on-single-page
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <template #footer>
        <span>
          <el-button @click="studioLogDialog = false">Cancel</el-button>
          <el-button type="primary" @click="studioLogDialog = false">OK</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog title="cpu监控日志" :visible.sync="cpuLogDialog" width="68%">
      <div v-loading="cpuLogLoading">
        <div class="data-table">
          <el-table id="cpuLog" class="data-box" border :data="cpuLogList" stripe style="width: 100%;">
            <el-table-column
              label="火焰图生成时间"
              prop="create_time"
              align="center"
            >
              <template slot-scope="scope">
                {{ formatDate(scope.row.create_time * 1000) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div>
                  <el-link type="primary" :underline="false" :href="scope.row.url" target="_blank">
                    查看
                  </el-link>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="img-no">
                <img
                  class="img-no-data"
                  src="../../../assets/images/img_table_no_data.png"
                />
                <div class="noCart">暂无数据</div>
              </div>
            </template>
          </el-table>
          <br>
          <div style="text-align: center;">
            <el-pagination
              background
              @current-change="cpuLogCurrentChange"
              :current-page="cpuLogPageInfo.page"
              :page-size="cpuLogPageInfo.page_size"
              layout="prev, pager, next,jumper"
              :total="cpuLogPageInfo.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-image-viewer
      :z-index="2222"
      v-if="cpuLogImgViewerVisible"
      :on-close="() => { cpuLogImgViewerVisible = false; }"
      :url-list="cpuLogImgList"
    />
  </div>
</template>
<script>
import {
  getSsLuaErrorData,
  getStudioMapLogFiles,
  studioMapPreDownload,
  studioMapDownload,
  getCpuLogList,
} from '@/api/charts';
import titleName from './title-btn.vue';
import { formatDate, htmlToExcel } from '@/utils';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

// const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 48 * 60 * 60 * 1000;
export default {
  components: {
    titleName,
    ElImageViewer,
  },
  data() {
    return {
      formatDate,
      luaErrorLogLoading: false,
      luaErrorLogDialog: false,
      luaErrorLogList: [],
      cpuLogLoading: false,
      cpuLogDialog: false,
      cpuLogList: [],
      cpuLogPageInfo: {
        page: 1,
        page_size: 10,
        total: 0,
      },
      cpuLogImgViewerVisible: false,
      cpuLogImgList: [],
      studioLogLoading: false,
      studioLogDialog: false,
      studioLogList: [],
      studioLogPageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      suin: '',
      dayNum: 2,
      appId: '',
      mapId: '',
      productState: {
        type: '1', // 1查询ss_lua_error 2查询通用服务器日志 3查询studio地图报错日志 4查询cpu监控日志
        room_type: '1', // 1正式服房间 2云服调试房间
      },
      query: {
        selectDate: [],
      },
      btnOptions: [
        { label: '查询ss_lua_error', id: '1' },
        { label: '查询通用服务器日志', id: '2' },
        { label: '查询studio地图报错日志', id: '3' },
        { label: '查询cpu监控日志', id: '4' },
      ],
      roomTypeOptions: [
        { label: '正式服房间', id: '1' },
        { label: '云服调试房间', id: '2' },
      ],
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 24 * 3600 * 1000 * 14 ||
            time.getTime() > Date.now()
          );
        },
      },
    };
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.query.selectDate = [
      formatDate(currTime - ONE_DAY),
      formatDate(currTime + 24 * 60 * 60 * 1000),
    ];
    this.mapId = this.$route.query.id;
  },
  methods: {
    handleStartDateTimeChange(val) {
      if (this.productState.type === '3') {
        this.$set(this.query.selectDate, 1, formatDate(new Date(val).getTime() + 6 * 60 * 60 * 1000));
      }
    },
    handleSearch() {
      console.log('handleSearch', this.productState.type);
      if (this.productState.type === '1') {
        this.luaErrorLogDialog = true;
        this.getLuaErrorLogList();
      } else if (this.productState.type === '2') {
        this.suin = '';
        this.studioLogPageInfo.page = 1;
        this.studioLogDialog = true;
        this.getStudioLogList();
      } else if (this.productState.type === '3') {
        if (new Date(this.query.selectDate[1]).getTime() - new Date(this.query.selectDate[0]).getTime() > 6 * 60 * 60 * 1000) {
          this.$message.error('查询时间不能超过6小时');
          return;
        }
        this.suin = '';
        this.studioLogPageInfo.page = 1;
        this.studioLogDialog = true;
        this.getStudioLogList();
      } else if (this.productState.type === '4') {
        this.cpuLogDialog = true;
        this.cpuLogPageInfo.page = 1;
        this.getCpuLogList();
      }
    },
    async getCpuLogList() {
      console.log('getCpuLogList');
      try {
        this.cpuLogLoading = true;
        const params = {
          mapid: this.appId || this.mapId,
          page: this.cpuLogPageInfo.page,
          page_size: this.cpuLogPageInfo.page_size,
        };
        const res = await getCpuLogList(params);
        console.log('getCpuLogList res', res);
        this.cpuLogLoading = false;
        if (res.code !== 0) {
          return;
        }

        this.cpuLogList = res.data.list || [];
        this.cpuLogPageInfo.total = res.data.total_count || 0;
      } catch (error) {
        console.log(error);
      } finally {
        this.cpuLogLoading = false;
      }
    },
    cpuLogView(row) {
      console.log('cpuLogView', row);
      this.cpuLogImgViewerVisible = true;
      this.cpuLogImgList = [row.url];
    },
    cpuLogCurrentChange(currPage) {
      this.cpuLogPageInfo.page = currPage;
      this.getCpuLogList();
    },
    handleSearchStudioLog() {
      this.studioLogPageInfo.page = 1;
      this.getStudioLogList();
    },
    getLuaErrorLogList() {
      try {
        this.luaErrorLogLoading = true;
        const params = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
          room_type: this.productState.room_type,
        };
        getSsLuaErrorData(params).then(res => {
          if (res.code === 0) {
            this.luaErrorLogList = res.data.list.map(item => {
              return {
                ...item,
                ellipsis: true,
              };
            });
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.luaErrorLogLoading = false;
      }
    },
    async getStudioLogList() {
      try {
        const params = {
          // aid: '73565471102894', // debugger
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
          ...this.studioLogPageInfo,
        };
        if (this.productState.type === '1') {
          params.room_type = this.productState.room_type;
        } else if (this.productState.type === '2' || this.productState.type === '3') {
          params.checkLuaError = this.productState.type === '3' ? 1 : 0;
        }
        if (this.suin) {
          params.suin = this.suin;
        }
        this.studioLogLoading = true;
        const res = await getStudioMapLogFiles(params);
        this.studioLogLoading = false;
        if (res.code !== 0) {
          return;
        }
        this.studioLogList = res.data.list || [];
        this.studioLogPageInfo.total = res.data.total || 0;
      } catch (error) {
        console.log(error);
      } finally {
        this.studioLogLoading = false;
      }
    },
    selectChange(val) {
      this.productState.type = val;
      if (val !== '3') {
        const currTime = new Date(new Date(new Date()).toDateString()).getTime();
        this.query.selectDate = [
          formatDate(currTime - ONE_DAY),
          formatDate(currTime + 24 * 60 * 60 * 1000),
        ];
      } else {
        const startTime = new Date().getTime() - 6 * 60 * 60 * 1000;
        this.query.selectDate = [formatDate(startTime), formatDate(new Date())];
      }
    },
    clickDate() {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      // this.query.selectDate[1] = this.endTime - ONE_DAY_TIME;
      if (this.dayNum == 2) {
        this.startTime = nowTime - 48 * 60 * 60 * 1000;
      } else if (this.dayNum == 7) {
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
      } else if (this.dayNum == 14) {
        this.startTime = nowTime - 14 * 24 * 60 * 60 * 1000;
      } else {
        this.startTime = nowTime - 24 * 60 * 60 * 1000;
      }
      this.query.selectDate[0] = formatDate(this.startTime);
      // this.query.selectDate[1] = formatDate(this.endTime);
      // this.getLuaErrorLogList();
      this.handleSearch();
    },
    async exportFn() {
      // TODO: 导出数据
      htmlToExcel.getExcel('#ssLuaErrLog', 'ss_lua_error日志');
    },
    async sdudioDownload(row) {
      try {
        const params1 = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
          filename: row.filename,
        };
        this.studioLogLoading = true;
        const res1 = await studioMapPreDownload(params1);
        this.studioLogLoading = false;
        if (res1.code !== 0) {
          return;
        }
        const params2 = {
          url: res1.data.downloadurl,
          token: res1.data.token,
          filename: row.filename,
        };
        this.studioLogLoading = true;
        const res2 = await studioMapDownload(params2);
        this.studioLogLoading = false;
        if (res2.status !== 200) {
          this.$message.error('下载失败');
          return;
        }
        const { data, headers } = res2;
        const blob = new Blob([data], { type: headers['content-type'] });
        const dom = document.createElement('a');
        const downUrl = window.URL.createObjectURL(blob);
        dom.href = downUrl;
        dom.download = decodeURIComponent(row.filename);
        dom.style.display = 'none';
        document.body.appendChild(dom);
        dom.click();
        dom.parentNode.removeChild(dom);
        window.URL.revokeObjectURL(downUrl);
        this.$message.success('下载成功');
      } catch (error) {
        console.error(error);
        this.studioLogLoading = false;
      }
    },
    CurrentChange(currPage) {
      this.studioLogPageInfo.page = currPage;
      this.getStudioLogList();
    },
  },
};
</script>

<style lang="scss" scoped>
#map_log_data {
  margin-bottom: 30px;
}
.row {
  display: flex;
  align-items: center;
  .room-type-radio {
    margin-bottom: 10px;
  }
}
.search_btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  color: #595959;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  background-color: #f4f4f5;
  margin-right: 20px;
  &.cpu_search_btn {
    border-left: 1px solid #d9d9d9;
    border-radius: 4px;
  }
}
.btnGroup {
  margin-bottom: 15px;
}
.data-box {
  margin-top: 20px;
}
.download-wrap {
  // float: right;
  border-radius: 4px;
  font-size: 11px;
  // font-weight: 600;
  margin-top: 18px;
  margin-left: 20px;
  // display: flex;
  align-items: center;
  cursor: pointer;
  color: #2b6ddf;
  img {
    margin-right: 8px;
  }
}
.mgr25 {
  margin-right: 25px;
}
</style>
